import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
export function SubMenuIcon({ dotColor, ...props }) {
    return (_jsx(Box, { sx: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: dotColor
        }, ...props }));
}
